import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { PRODUCTS } from "../../data";

export const Products = () => (
  <section id="products" className="relative py-24 md:py-40 bg-orbital noise-overlay" data-testid="products-section">
    <div className="mx-auto max-w-[1600px] px-5 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24">
        <Reveal>
          <div>
            <div className="flex items-center gap-4 font-mono text-xs uppercase tracking-[0.25em] text-forge mb-6">
              <span className="w-10 h-px bg-forge" />
              Systems / 05 Categories
            </div>
            <h2 className="font-head font-bold uppercase tracking-tight text-4xl md:text-6xl leading-[0.92] max-w-2xl">
              Built for residential, <br className="hidden md:block" /> commercial & industrial.
            </h2>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <a
            href="#contact"
            data-testid="products-cta"
            className="font-mono text-xs uppercase tracking-[0.2em] border border-white/25 px-6 py-4 hover:border-forge hover:text-forge transition-colors inline-flex items-center gap-2"
          >
            Request Spec Sheet <ArrowUpRight size={15} />
          </a>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {PRODUCTS.map((p, i) => (
          <Reveal key={p.id} delay={(i % 3) * 0.1}>
            <motion.div
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 260, damping: 22 }}
              className="group relative bg-void border border-white/10 chamfer h-full flex flex-col"
              data-testid={`product-card-${p.id}`}
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover grayscale-[0.3] group-hover:grayscale-0 group-hover:scale-110 transition-all duration-700 ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-void via-transparent to-transparent" />
                <span className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.2em] bg-void/80 border border-white/10 px-3 py-1.5 text-electric">
                  {p.tag}
                </span>
                <span className="absolute top-4 right-5 font-head font-black text-5xl text-plasma/20 group-hover:text-forge transition-colors">
                  {p.index}
                </span>
              </div>

              <div className="p-6 md:p-8 flex flex-col flex-1">
                <h3 className="font-head font-bold uppercase text-2xl md:text-3xl leading-none tracking-tight mb-4">
                  {p.name}
                </h3>
                <p className="text-plasma/60 text-sm leading-relaxed mb-6 flex-1">{p.desc}</p>
                <div className="flex flex-wrap gap-2">
                  {p.specs.map((s) => (
                    <span key={s} className="font-mono text-[10px] uppercase tracking-wider text-plasma/70 border border-white/10 px-2.5 py-1">
                      {s}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          </Reveal>
        ))}

        <Reveal delay={0.2}>
          <a
            href="#contact"
            data-testid="product-card-custom"
            className="group relative bg-forge text-void chamfer h-full min-h-[300px] flex flex-col justify-between p-8 hover:bg-electric transition-colors"
          >
            <span className="font-mono text-[10px] uppercase tracking-[0.2em]">Need something custom?</span>
            <div>
              <h3 className="font-head font-black uppercase text-4xl md:text-5xl leading-[0.9] tracking-tight mb-4">
                Talk to an engineer
              </h3>
              <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em]">
                Start enquiry <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </span>
            </div>
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
